const items = [
  "Trust",
  "Education",
  "Community",
  "Growth",
  "Accessibility",
  "Mundeke Goraya",
  "Daska",
  "Sialkot",
];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {items.map((item) => (
      <span key={item + (hidden ? "-dup" : "")} className="flex items-center">
        <span className="whitespace-nowrap px-6 font-display text-sm font-bold uppercase tracking-[0.25em] text-brand">
          {item}
        </span>
        <span className="h-1.5 w-1.5 rounded-full bg-brand-amber" aria-hidden="true" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="values-marquee"
    className="overflow-hidden border-y border-brand-line bg-white py-4"
    role="presentation"
  >
    <div className="marquee-track">
      <Row hidden={false} />
      <Row hidden />
    </div>
  </div>
);
